import type { Variants } from '@ds/components/Tag'

import type { OrderLine } from '../../../../Tab.types'

type OrderLineStateCode = OrderLine['state']['code']

export const TAG_VARIANTS_BY_ORDERLINE_STATE_CODE: Record<
  OrderLineStateCode,
  Variants
> = {
  NEW: 'primary',
  PAID: 'primary',
  VALIDATED: 'primary',
  SHIPPED: 'success',
  CANCELLED: 'danger',
  REFUNDED_PRE_DELIVERY: 'secondary',
  REFUNDED_POST_DELIVERY: 'secondary',
  NOT_PAID: 'danger',
  ON_HOLD: 'alternate',
}
